// extracted by mini-css-extract-plugin
export default {"card-info":"styles_card-info__rovyt","head":"styles_head__2M4bq","icon":"styles_icon__l9C0T"};